<div class="financial-statement-import-form" (click)="triggerLoseFocus()">
    <div class="upload-section">
        <div class="file-upload-title aum-typo-paragraph-l">
            {{ 'aumico_core_file_upload_title' | i18next }}
            <span class="aumico-pattern-icon-question-mark here-aumico-pattern-icon"> </span>
        </div>
        <div class="upload-container">
            <div class="file-upload-components file-upload section-detail">
                <aumico-file-upload
                    *ngIf="!importBalanceAndIncomeSeparately"
                    [tint]="true"
                    [accept]="'.xls,.xlsx,.XLSX,.XLS'"
                    (fileChange)="onBalanceAndIncomeCombinedFileChanged($event)"
                >
                </aumico-file-upload>

                <aumico-file-upload
                    *ngIf="importBalanceAndIncomeSeparately"
                    [tint]="true"
                    [accept]="'.xls,.xlsx,.XLSX,.XLS'"
                    [instructionTextKey]="balanceInstructionTextKey"
                    [instructionLabelKey]="balanceInstructionLabelKey"
                    [title]="balanceTitleKey | i18next "
                    (fileChange)="onBalanceSeparateFileChanged($event)"
                >
                </aumico-file-upload>
                <aumico-file-upload
                    *ngIf="importBalanceAndIncomeSeparately"
                    [tint]="true"
                    [accept]="'.xls,.xlsx,.XLSX,.XLS'"
                    [instructionTextKey]="incomeInstructionTextKey"
                    [instructionLabelKey]="incomeInstructionLabelKey"
                    [title]="incomeStatementTitleKey | i18next "
                    (fileChange)="onIncomeSeparateFileChanged($event)"
                >
                </aumico-file-upload>
            </div>
            <div>
                <aumico-annualReport-financial-statement-import-options
                    *ngIf="importReqognizedFormat == PartnerExcelImportFileType.UNKNOWN"
                    [enableOptions]="enableImportOptions"
                    [projectsList]="projectsList$ | async"
                    [activeAnnualReportId]="activeAnnualReportId"
                    [userLanguage]="userLanguage"
                    [activeArNavigation]="activeArNavigation$ | async"
                    [autofillOptions]="autofillOptions"
                    [uploadAndMappingAutoFillAnnualReportIdExist]="uploadAndMappingAutoFillAnnualReportIdExist"
                    [uploadAndMappingAutoFillAnnualReportToggleDisabled]="uploadAndMappingAutoFillAnnualReportToggleDisabled"
                    (importOptions)="handleImportOptions($event)"
                    (selectedAnnualReportIdToAutofillFrom)="handleSelectedAnnualReportIdToAutofillFrom($event)"
                >
                </aumico-annualReport-financial-statement-import-options>
            </div>
        </div>
    </div>
    <div
        *ngIf="
            priorYearUnmatchableAccountsDetectedBalance ||
            priorYearUnmatchableAccountsDetectedIncome ||
            newShareholderBalanceAccounts.length > 0 ||
            newShareholderIncomeAccounts.length > 0
        "
        class="alert alert-warning"
    >
        <div class="alert-content">
            <div class="alert-icon">
                <span>🚨</span>
            </div>
            <div class="alert-message">
                <p class="main-warning" [innerHTML]="'aumico_alert_duplicate_prior_year_title' | i18next"></p>
            </div>
        </div>
        <div class="table-container" *ngIf="displayAccounts.length > 0">
            <table class="comparison-table">
                <thead>
                    <tr>
                        <th class="col-number">{{ 'aumico_templates_account_mapping_child_form_number' | i18next }}</th>
                        <th class="col-name">{{ 'aumico_templates_account_mapping_child_form_name' | i18next }}</th>
                        <th class="col-amount">
                            {{ 'aumico_reports_equality_check_print_preview_table_current_year_column' | i18next }}
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let account of displayAccounts">
                        <td class="col-number">{{ account.accountNumber }}</td>
                        <td class="col-name">
                            {{ account.name }}{{ account.shareholder ? ' - ' + account.shareholder : '' }}
                        </td>
                        <td class="col-amount">{{ account.closingBalance | finNumber }}</td>
                    </tr>
                </tbody>
            </table>
        </div>

        <div
            class="alert-content"
            *ngIf="
                priorYearUnmatchableAccountsDetectedBalanceFixed ||
                priorYearUnmatchableAccountsDetectedIncomeFixed
            "
        >
            <div class="alert-icon">
                <span>✅</span>
            </div>
            <div class="alert-message">
                <p
                    *ngIf="priorYearUnmatchableAccountsDetectedBalanceFixed"
                    class="auto-fix-msg"
                    [innerHTML]="'aumico_alert_fixed_balance_sheet' | i18next:{
                    priorYearUnmatchableAccountsDetectedBalanceFixedColNo:
                    priorYearUnmatchableAccountsDetectedBalanceFixedColNo
                }"
                ></p>
                <p
                    *ngIf="priorYearUnmatchableAccountsDetectedIncomeFixed"
                    class="auto-fix-msg"
                    [innerHTML]="'aumico_alert_fixed_income_statement' | i18next:{
                    priorYearUnmatchableAccountsDetectedIncomeFixedColNo:
                    priorYearUnmatchableAccountsDetectedIncomeFixedColNo
                }"
                ></p>
            </div>
        </div>
        <div
            class="alert-content"
            *ngIf="(priorYearUnmatchableAccountsDetectedBalance && !priorYearUnmatchableAccountsDetectedBalanceFixed) || 
           (priorYearUnmatchableAccountsDetectedIncome && !priorYearUnmatchableAccountsDetectedIncomeFixed)"
        >
            <div class="alert-icon">
                <span>⚠️</span>
            </div>
            <div class="alert-message">
                <p
                    *ngIf="priorYearUnmatchableAccountsDetectedBalance && !priorYearUnmatchableAccountsDetectedBalanceFixed"
                    class="auto-fix-msg"
                    [innerHTML]="'aumico_alert_duplicate_prior_year_processed_without_fix' | i18next"
                ></p>

                <p
                    *ngIf="(priorYearUnmatchableAccountsDetectedIncome && !priorYearUnmatchableAccountsDetectedIncomeFixed) && 
                   !(priorYearUnmatchableAccountsDetectedBalance && !priorYearUnmatchableAccountsDetectedBalanceFixed)"
                    class="auto-fix-msg"
                    [innerHTML]="'aumico_alert_duplicate_prior_year_processed_without_fix' | i18next"
                ></p>
            </div>
        </div>
    </div>
    <div *ngIf="importReqognizedFormat === PartnerExcelImportFileType.DATEV_MASTER" class="importfile-info">
        <span *ngIf="!isAiFixed"> {{ 'aumico_annual_report_datev_master_file_detected' | i18next }} </span>
        <div *ngIf="isAiFixed" class="ai-fixed-header">
            <span class="ai-fixed-badge">{{ 'aumico_ai_fixed_badge' | i18next }}</span>
        </div>

        <ng-container *ngIf="importedTaxonomyErros.length === 0">
            <ar-special-fli-settings-form
                [canUseUncovershorfall]="canUseUncovershorfall"
                [canUseEquity]="canUseEquity"
                [template]="importedTaxonomy.rawBalanceTemplate"
                [groupOptions]="importedTaxonomy.rawBalanceTemplate.groups"
                [fliOptions]="importedTaxonomy.rawBalanceTemplate.flis"
                [assetsFliOptions]="importedTaxonomy.rawBalanceTemplate.flisAssets"
                [liaFliOptions]="importedTaxonomy.rawBalanceTemplate.flisLia"
                (templateSpecialFlisFormComplete)="onTemplateSpecialFlisFormCompleted($event)"
                (specialFlisSelections)="onSpecialFlisSelectionChange($event)"
            ></ar-special-fli-settings-form>
        </ng-container>
        <ng-container *ngIf="importedTaxonomyErros.length > 0">
            {{'aumico_annual_report_datev_error_detected' | i18next}}
            <ul>
                <li *ngFor="let error of importedTaxonomyErros">{{error | i18next }}</li>
            </ul>
        </ng-container>

        <!-- AI Fixer Panel — shown inline below the error list, above Show Settings -->
        <ai-fixer-panel
            *ngIf="aiDelegate?.showPanel && aiDelegate?.jobRequest"
            [jobRequest]="aiDelegate?.jobRequest"
            [firebaseToken]="aiDelegate?.firebaseToken ?? ''"
            (completed)="onAiCompleted($event)"
            (accepted)="aiDelegate?.onAccepted($event)"
            (rejected)="aiDelegate?.onRejected()"
        >
            <!-- Preview button projected into the actions bar alongside Accept / Reject -->
            <button
                ai-actions
                aum-button
                color="basic"
                class="ai-preview-action-btn"
                [disabled]="!aiProposalSections"
                (click)="openTaxonomyPreview()"
            >
                {{ 'aumico_ai_taxonomy_preview_btn_preview' | i18next }}
            </button>
        </ai-fixer-panel>

        <div>
            <button aum-button (click)="toggleSettings()" color="basic" *ngIf="hideDefaultSettings">
                {{'aumico_annual_report_show_settings' | i18next }}
            </button>
            <button aum-button (click)="toggleSettings()" color="basic" *ngIf="!hideDefaultSettings">
                {{'aumico_annual_report_hide_settings' | i18next }}
            </button>
        </div>
        <!-- <aumico-taxonomy-preview [taxonomy]="importedTaxonomy"></aumico-taxonomy-preview> -->
    </div>
    <div *ngIf="importReqognizedFormat === PartnerExcelImportFileType.DATEV_ACCOUNTS" class="importfile-info">
        <span> {{ 'aumico_annual_report_datev_account_file_detected' | i18next }} </span>
        <div>
            <button aum-button (click)="toggleSettings()" color="basic" *ngIf="hideDefaultSettings">
                {{'aumico_annual_report_show_settings' | i18next }}
            </button>
            <button aum-button (click)="toggleSettings()" color="basic" *ngIf="!hideDefaultSettings">
                {{'aumico_annual_report_hide_settings' | i18next }}
            </button>
        </div>
    </div>
    <hr
        *ngIf="
            (spreadSheetData != null && spreadSheetData.sheets.length > 0) ||
            (balanceSpreadSheetData != null && balanceSpreadSheetData.sheets.length > 0) ||
            (incomeSpreadSheetData != null && incomeSpreadSheetData.sheets.length > 0)
        "
    />
    <div
        class="row"
        *ngIf="
            (spreadSheetData != null && spreadSheetData.sheets.length > 0) ||
            (balanceSpreadSheetData != null && balanceSpreadSheetData.sheets.length > 0) ||
            (incomeSpreadSheetData != null && incomeSpreadSheetData.sheets.length > 0)
        "
        (click)="stopPropagation($event)"
    >
        <div
            class="col-5 overflow-auto spread-sheet-preview preview-sheet-height d-flex scroll-style"
            *ngIf="!importBalanceAndIncomeSeparately"
        >
            <aumico-annualReport-spreadsheet-preview-component
                *ngIf="!hideDefaultSettings"
                [data]="spreadSheetData"
                (spreadSheetClick)="onSpreadSheetClick($event)"
                [balanceHighlightedRows]="balanceHighlightedRows"
                [incomeHighlightedRows]="incomeHighlightedRows"
            >
            </aumico-annualReport-spreadsheet-preview-component>
        </div>
        <mat-tab-group *ngIf="importBalanceAndIncomeSeparately" class="col-5 overflow-auto">
            <mat-tab label="{{ balanceTitleKey | i18next  }}">
                <div class="spread-sheet-preview preview-sheet-height d-flex scroll-style">
                    <aumico-annualReport-spreadsheet-preview-component
                        [data]="balanceSpreadSheetData"
                        (spreadSheetClick)="onSpreadSheetClick($event)"
                        [balanceHighlightedRows]="balanceHighlightedRows"
                    >
                    </aumico-annualReport-spreadsheet-preview-component>
                </div>
            </mat-tab>
            <mat-tab label="{{ incomeStatementTitleKey | i18next  }}">
                <div class="spread-sheet-preview preview-sheet-height d-flex scroll-style">
                    <aumico-annualReport-spreadsheet-preview-component
                        [data]="incomeSpreadSheetData"
                        (spreadSheetClick)="onSpreadSheetClick($event)"
                        [incomeHighlightedRows]="incomeHighlightedRows"
                    >
                    </aumico-annualReport-spreadsheet-preview-component>
                </div>
            </mat-tab>
        </mat-tab-group>
        <div class="col-7">
            <div class="row">
                <div class="import-definition col-6" (click)="stopPropagation($event)" *ngIf="!hideDefaultSettings">
                    <aumico-annualReport-financial-statement-import-definition-component
                        [data]="balanceSpreadSheetData"
                        [title]="balanceTitleKey | i18next "
                        [spreadSheetClickData]="clickedCell"
                        [importDefinition]="activeBalanceFinancialStatementImportDefinition"
                        [currentFilledData]="currentFilledBalanceFinancialStatementImportDefinition"
                        (importDefinitionCompleted)="onBalanceImportDefinitionCompleted($event)"
                        [autoFillApplied]="autoFillApplied"
                        [noPreviousYearData]="noPreviousYearData"
                        [priorYearUnmatchableAccountsDetected]="priorYearUnmatchableAccountsDetectedBalance || newShareholderBalanceAccounts.length > 0"
                        [isPreviousYearDataTakenFromPreviousAnnualReport]="
                            isPreviousYearDataTakenFromPreviousBalanceAnnualReport
                        "
                        [showShareholderInformation]="showShareholderInformation"
                    >
                    </aumico-annualReport-financial-statement-import-definition-component>
                </div>
                <div
                    class="import-definition col-6"
                    (click)="stopPropagation($event)"
                    *ngIf="showIncomeImportDefinition && !hideDefaultSettings"
                >
                    <aumico-annualReport-financial-statement-import-definition-component
                        [data]="incomeSpreadSheetData"
                        [title]="incomeStatementTitleKey | i18next "
                        [spreadSheetClickData]="clickedCell"
                        [importDefinition]="activeIncomeFinancialStatementImportDefinition"
                        [currentFilledData]="currentFilledIncomeFinancialStatementImportDefinition"
                        [definitionToCopy]="definitionToCopy"
                        (importDefinitionCompleted)="onIncomeImportDefinitionCompleted($event)"
                        [autoFillApplied]="autoFillApplied"
                        [noPreviousYearData]="noPreviousYearData"
                        [priorYearUnmatchableAccountsDetected]="priorYearUnmatchableAccountsDetectedIncome || newShareholderIncomeAccounts.length > 0"
                        [isPreviousYearDataTakenFromPreviousAnnualReport]="
                            isPreviousYearDataTakenFromPreviousIncomeAnnualReport
                        "
                        [showShareholderInformation]="showShareholderInformation"
                    >
                    </aumico-annualReport-financial-statement-import-definition-component>
                </div>
            </div>
            <form [formGroup]="formGroup" *ngIf="sameSheetFlag && balanceCompleted && incomeStatementCompleted">
                <hr />
                <div class="row">
                    <div class="col-6">
                        <aumico-number-input
                            class="range-field"
                            [decimalPlaces]="0"
                            [allowNegative]="false"
                            [control]="formGroup.get('balanceAccountsStartRow')"
                            [errorStateMatcher]="balanceRangeErrorStateMatcher"
                        >
                            <aum-form-field-label
                                >{{ 'aumico_annual_report_import_form_balance_start' | i18next }}</aum-form-field-label
                            >
                            <aum-form-error
                                *ngIf="
                                formGroup.errors?.[invalidBalanceRange]"
                            >
                                {{ 'aumico_annual_report_import_form_error_invalid_row_input' | i18next }}
                            </aum-form-error>
                        </aumico-number-input>
                        <hr />

                        <aumico-number-input
                            class="range-field"
                            [decimalPlaces]="0"
                            [allowNegative]="false"
                            [control]="formGroup.get('balanceAccountsEndRow')"
                            [errorStateMatcher]="balanceRangeErrorStateMatcher"
                        >
                            <aum-form-field-label
                                >{{ 'aumico_annual_report_import_form_balance_end' | i18next }}</aum-form-field-label
                            >
                            <aum-form-error
                                *ngIf="
                                formGroup.errors?.[invalidBalanceRange]"
                            >
                                {{ 'aumico_annual_report_import_form_error_invalid_row_input' | i18next }}
                            </aum-form-error>
                        </aumico-number-input>
                    </div>
                    <div class="col-6">
                        <aumico-number-input
                            class="range-field"
                            [decimalPlaces]="0"
                            [allowNegative]="false"
                            [control]="formGroup.get('incomeAccountsStartRow')"
                            [errorStateMatcher]="incomeRangeErrorStateMatcher"
                        >
                            <aum-form-field-label
                                >{{ 'aumico_annual_report_import_form_income_start' | i18next }}</aum-form-field-label
                            >

                            <aum-form-error
                                *ngIf="
                                formGroup.errors?.[invalidIncomeRange]
                            "
                            >
                                {{ 'aumico_annual_report_import_form_error_invalid_row_input' | i18next }}
                            </aum-form-error>
                        </aumico-number-input>

                        <hr />

                        <aumico-number-input
                            class="range-field"
                            [decimalPlaces]="0"
                            [allowNegative]="false"
                            [control]="formGroup.get('incomeAccountsEndRow')"
                            [errorStateMatcher]="incomeRangeErrorStateMatcher"
                        >
                            <aum-form-field-label
                                >{{ 'aumico_annual_report_import_form_income_end' | i18next }}</aum-form-field-label
                            >

                            <aum-form-error
                                *ngIf="
                                formGroup.errors?.[invalidIncomeRange]
                            "
                            >
                                {{ 'aumico_annual_report_import_form_error_invalid_row_input' | i18next }}
                            </aum-form-error>
                        </aumico-number-input>
                    </div>
                </div>
                <mat-error *ngIf="formGroup.errors?.['isOverlappingRanges']">
                    {{ 'aumico_annual_report_import_form_error_overlapping' | i18next }}
                </mat-error>
            </form>

            <div class="interpretation" *ngIf="showInterpretation && !hideDefaultSettings">
                <hr />
                <aumico-annualReport-financial-statement-import-interpretation
                    (interpretationFormValueChangesEvent)="setInterpretationFormValue($event)"
                    [interpretationData]="balanceFinancialStatementSource.interpretation"
                    [accountFilterData]="balanceFinancialStatementSource.accountsFilter"
                    (accountFilterFormValueChangesEvent)="setAccountFilterFormValue($event)"
                    (accountFilterFormStatusChangesEvent)="onAccountFilterFormStatusChange($event)"
                >
                </aumico-annualReport-financial-statement-import-interpretation>
            </div>
        </div>
    </div>
</div>
